import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2.5),
  },
  youtubePlayer: {},
}));
